import ProcessingOltsCompanyAdminComponent from "../components/companyAdmin/ProcessingOltsCompanyAdmin";
const CompanyAdminProcessingOlts = () => {
  return (
    <>
      <ProcessingOltsCompanyAdminComponent />
    </>
  );
};
export default CompanyAdminProcessingOlts;
